import { useEffect, useState } from "react"
import { type CartItemSchema, type CartSchema, CartService } from "../client"

import { Table, TableContainer, Tbody, Thead, Tr } from "@chakra-ui/react"

const MiniCart: React.FC = () => {
  const [cart, setCart] = useState<CartSchema | null>(null)

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const cartData = await CartService.getCart() // Fetch cart data
        setCart(cartData)
      } catch (error) {
        console.error("Failed to fetch cart data:", error)
      }
    }

    fetchCart()
  }, [])

  if (!cart || cart.items.length === 0) {
    return <div>Your cart is empty.</div>
  }
  const totalPrice = cart.items.reduce(
    (sum, item) => sum + Number(item.price),
    0,
  )

  return (
    <TableContainer>
      <Table>
        <Thead>
          <Tr>
            <th colSpan={2}>Cart</th>
          </Tr>
        </Thead>
        <Tbody>
          <>
            {cart.items.map((item: CartItemSchema) => (
              <tr key={item.id}>
                <td>{item.item_name}</td>
                <td>
                  ${(Math.round(Number(item.price) * 100) / 100).toFixed(2)}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td>
                <strong>${totalPrice.toFixed(2)}</strong>
              </td>
            </tr>
          </>
        </Tbody>
      </Table>
    </TableContainer>
  )
}

export default MiniCart
